import React from 'react'
import { ReactComponent as Overview } from '../../../assets/icons/overview.svg'
import { ReactComponent as StomatologyIcon } from '../../../assets/icons/stomatology.svg'
import { ReactComponent as PulmonologyIcon } from '../../../assets/icons/pulmonology.svg'
import { ReactComponent as AptsIcon } from '../../../assets/icons/appointments.svg'
import { ReactComponent as PaysIcon } from '../../../assets/icons/pays.svg'
import { ReactComponent as Users } from '../../../assets/icons/users.svg'

const links = (isAdmin, t) => {
  if (!t) {
    return []
  }
  const basic = [
    {
      name: t('overview'),
      path: 'dashboard',
      icon: <Overview />
    },
    {
      name: t('stomatology_cap'),
      path: 'stomatology',
      icon: <StomatologyIcon />
    },
    {
      name: t('pulmonology_cap'),
      path: 'pulmonology',
      icon: <PulmonologyIcon />
    },
    {
      name: t('appointments'),
      path: 'appointments',
      icon: <AptsIcon />
    },
    {
      name: t('payment_review'),
      path: 'payments',
      icon: <PaysIcon />
    }
  ]
  const admins = [
    {
      name: t('management'),
      path: 'admin',
      icon: <Users />
    }
  ]
  return isAdmin ? [...basic, ...admins] : basic
}

export default links
